import React from 'react';

interface TableCellProps {
  children: React.ReactNode;
  width?: string;
  onClick?: () => void;
}

export const TableCell: React.FC<TableCellProps> = ({
  children,
  width,
  onClick
}) => (
  <div
    className={`${
      width || 'flex-1'
    } h-12 px-4 py-2 bg-white border-r border-b border-l border-[#EEEFF2] flex items-center`}
    onClick={onClick}>
    {children}
  </div>
);
